import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export function useEvents() {
  const { token } = useAuth();
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  const fetch = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try { const data = await api.getEvents(token); setEvents(data); setError(null); }
    catch(e) { setError(e.message); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetch(); }, [fetch]);

  async function createEvent(form) {
    const ev = await api.createEvent(form, token);
    await fetch(); return ev;
  }
  async function updateEvent(id, updates) {
    const ev = await api.updateEvent(id, updates, token);
    await fetch(); return ev;
  }
  async function approveDish(dishId) {
    await api.updateDish(dishId, { status: 'approved' }, token);
    await fetch();
  }
  async function declineDish(dishId) {
    await api.updateDish(dishId, { status: 'declined' }, token);
    await fetch();
  }
  async function suggestDish(event_id, form) {
    await api.suggestDish({ event_id, ...form }, token);
    await fetch();
  }
  async function rateDish(dishId, rating) {
    await api.rateDish(dishId, { rating }, token);
    await fetch();
  }
  async function claimWishlistItem(eventId, wishId) {
    await api.claimWishlistItem(eventId, wishId, token);
    await fetch();
  }
  async function addGuest(eventId, email) {
    await api.addGuest(eventId, { email }, token);
    await fetch();
  }
  async function addWishlistItem(eventId, description) {
    await api.addWishlistItem(eventId, { description }, token);
    await fetch();
  }

  return { events, loading, error, refresh: fetch, createEvent, updateEvent, approveDish, declineDish, suggestDish, rateDish, claimWishlistItem, addGuest, addWishlistItem };
}
